import React, { useEffect, useState } from 'react';
import { Button, Card, Form, Modal, Row, Col, } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { FaPlusCircle, FaRegClock, FaUserCheck } from 'react-icons/fa';
import CatPermisos from '../../../Services/Catalogos/CatPermisos';
import CatEmpleados from '../../../Services/Catalogos/CatEmpleados';
import { DTOPermiso } from './DTO/DTOPermiso';
import DTOEmpleadoVac from '../../Catalogos/CatEmpleados/DTO/DTOEmpleadoVac';
import { MsgInformativo } from '../../../Utils/Toast/msgInformativo';
import { FaClipboardList } from 'react-icons/fa';
import {  BsFileEarmarkText, BsCalendarCheck , BsTrash } from "react-icons/bs";  // ← Agrega BsFileEarmarkText


import NominaServices from '../../../Services/Catalogos/Nomina'; 
import { BsFileEarmarkArrowUp, BsEye } from 'react-icons/bs';






const CatPermisosUsuario = () => {
  const [empleado, setEmpleado] = useState<DTOEmpleadoVac | null>(null);
  const [permisos, setPermisos] = useState<DTOPermiso[]>([]);
  const [showModal, setShowModal] = useState(false);

  // Dentro del componente, añade estos estados nuevos
const [archivoPermiso, setArchivoPermiso] = useState<File | null>(null);
const [showAdjuntosModal, setShowAdjuntosModal] = useState(false);
const [permisoSeleccionado, setPermisoSeleccionado] = useState<DTOPermiso | null>(null);
const [adjuntosActuales, setAdjuntosActuales] = useState<any[]>([]);
  

  const [nuevoPermiso, setNuevoPermiso] = useState<DTOPermiso>({
    id: 0,
    fechaPermiso: '',
    fechaSolicitud: new Date().toISOString().split('T')[0],
    nombreEmpleado: '',
    puestoEmpleado: '',
    motivo: '',
    horaInicio: '',
    horaFin: '',
    permisoConSueldo: false,
    autorizador: '',
    observaciones: '',
    estado: 'Pendiente',
    fechaAceptacionPermiso: null,
    correo: '', // Asegúrate de que este campo esté presente
    numEmpleado: '', 
    esDiaCompleto: false,
  });

  const [msg, setMsg] = useState('');
  const [header, setHeader] = useState('');
  const [showMsg, setShowMsg] = useState(false);
  const msgColor = 'primary';
    useEffect(() => {
      const interval = setInterval(() => {
        if (empleado?.numEmpleado) {
          cargarPermisos(empleado.numEmpleado);
        }
      }, 10000); 

      return () => clearInterval(interval);
    }, [empleado]);



  const cargarEmpleado = async () => {
    const userIdString = localStorage.getItem("UserId");

    if (!userIdString) {
      console.error("No se encontró UserId en localStorage.");
      return;
    }

    const userId = Number(JSON.parse(userIdString));

    if (isNaN(userId) || userId <= 0) {
      console.error("UserId no es válido:", userIdString);
      return;
    }

    try {
      const response = await CatEmpleados.GetIdEmpleado(userId);

      if (!response.data || response.data.length === 0) {
        console.error("No se encontró información del empleado.");
        return;
      }

      const user = response.data[0];

      setEmpleado(user);

      setNuevoPermiso(prev => ({
        ...prev,
        nombreEmpleado: user.nombreEmpleado,
        puestoEmpleado: user.departamento,
        numEmpleado: user.numEmpleado
      }));

      cargarPermisos(user.numEmpleado);
    } catch (error) {
      console.error("Error al obtener datos del empleado:", error);
    }
  };

  const cargarPermisos = (numEmpleado: string) => {
    CatPermisos.GetPermisosPorEmpleado(numEmpleado)
      .then((res) => setPermisos(res.data))
      .catch((err) => console.error('Error al obtener permisos:', err));
  };

 

const mostrarToast = (mensaje: string, titulo: string, color: string) => {
    setMsg(mensaje);
    setHeader(titulo);
    setShowMsg(true);
    
};




const insertarPermiso = async () => {
  if (!empleado) return;

  if (!nuevoPermiso.fechaPermiso || !nuevoPermiso.motivo) {
    setMsg('Faltan campos obligatorios como Fecha y Motivo.');
    setHeader('Atención');
    setShowMsg(true);
    return;
  }

  
  const hoy = new Date();
  hoy.setHours(0, 0, 0, 0);

  
  // Validación de fecha: No permitir fechas mayores a 1 semana en el pasado
  const fechaPermiso = new Date(nuevoPermiso.fechaPermiso);
  const fechaActual = new Date();
  const unaSemanaAtras = new Date();
  unaSemanaAtras.setDate(fechaActual.getDate() - 7);
  
  // Normalizar fechas (solo día, sin hora)
  fechaPermiso.setHours(0, 0, 0, 0);
  unaSemanaAtras.setHours(0, 0, 0, 0);
  fechaActual.setHours(0, 0, 0, 0);

  if (fechaPermiso < unaSemanaAtras) {
    setHeader('Error de fecha');
    setMsg('Solo se pueden registrar permisos con fecha hasta una semana antes de la fecha actual.');
    setShowMsg(true);
    return;
  }


  // ⏰ Validaciones de horario si no es día completo
  if (!nuevoPermiso.esDiaCompleto) {
    const horaInicio = nuevoPermiso.horaInicio;
    const horaFin = nuevoPermiso.horaFin;

    if (!horaInicio || !horaFin) {
      setMsg('Debes ingresar hora de salida y regreso.');
      setHeader('Horario requerido');
      setShowMsg(true);
      return;
    }

    const horaMinima = '08:00';
    const horaMaxima = '20:00';


    

    if (horaInicio < horaMinima || horaInicio > horaMaxima) {
      setMsg('La hora de salida debe estar entre 08:00.');
      setHeader('Hora de salida inválida');
      setShowMsg(true);
      return;
    }

    if (horaFin < horaMinima || horaFin > horaMaxima) {
      setMsg('La hora de regreso solo es apicable  antes de 20:00.');
      setHeader('Hora de regreso inválida');
      setShowMsg(true);
      return;
    }

    if (horaFin <= horaInicio) {
      setMsg('La hora de regreso debe ser posterior a la hora de salida.');
      setHeader('Orden de horas inválido');
      setShowMsg(true);
      return;
    }
  }

  const permisoAInsertar: DTOPermiso = {
    ...nuevoPermiso,
    numEmpleado: empleado.numEmpleado
  };

  // Guardamos la fecha en una constante para que no se pierda si el form se limpia
  const fechaParaAdjunto = nuevoPermiso.fechaPermiso;

  try {
    // 1. Insertamos el permiso
    await CatPermisos.PosInsertarPermiso(permisoAInsertar);
    
    

    // 3. SUBIR ARCHIVO (Si seleccionó uno)
    if (archivoPermiso) {
      const formData = new FormData();
      formData.append("NumEmpleado", empleado.numEmpleado);
      formData.append("FechaInicio", fechaParaAdjunto);
      formData.append("FechaFin", fechaParaAdjunto);
      
      // 🔥 Lógica dinámica: PSS para día completo, PPA para parcial
      const tipoParaDocumento = nuevoPermiso.esDiaCompleto ? "PSS" : "PPA";
      formData.append("TipoAdjunto", tipoParaDocumento);
      
      formData.append("Archivo", archivoPermiso);

      await NominaServices.subirAdjunto(formData);
    }

 // 4. ENVÍO DE CORREO (Tu lógica original recuperada)
    const correoSupervisor = localStorage.getItem('correoSupervisor')?.replace(/"/g, '');
    if (nuevoPermiso.estado === 'Pendiente' && correoSupervisor) {
      const notificacion = {
        id: 0,
        numEmpleado: permisoAInsertar.numEmpleado,
        nombreEmpleado: permisoAInsertar.nombreEmpleado,
        correo: correoSupervisor,
        motivo: permisoAInsertar.motivo,
        fechaPermiso: permisoAInsertar.fechaPermiso,
        estado: permisoAInsertar.estado, 
        observaciones: permisoAInsertar.observaciones || ''
      };

      try {
        await CatPermisos.EnviarCorreoPermiso(notificacion);
      } catch (error) {
        console.error('Error al enviar correo:', error);
      }
    }



    // 3. Éxito y limpieza
    setShowModal(false);
    setMsg('Permiso y comprobante registrados correctamente.');
    setHeader('Éxito');
    setShowMsg(true);
    cargarPermisos(empleado.numEmpleado);
    limpiarFormulario();
    setArchivoPermiso(null); // Reset del archivo
  } catch (err: any) {
    console.error("Error completo:", err);
    setHeader('Error');
    setMsg('Se guardó el permiso pero hubo un detalle con el archivo.');
    setShowMsg(true);
  }
 








};


  const limpiarFormulario = () => {
    setNuevoPermiso(prev => ({
      ...prev,
      fechaPermiso: '',
      motivo: '',
      horaInicio: '',
      horaFin: '',
      permisoConSueldo: false,
      autorizador: '',
      observaciones: '',
      estado: 'Pendiente',
      esDiaCompleto: false
    }));
  };

  

  useEffect(() => {
    cargarEmpleado();
  }, []);

 



  const generarCredencialPermiso = async (row: DTOPermiso) => {
  const response = await CatEmpleados.GetSuperFirma(row.numEmpleado);
  const numSupervisor = response.data?.numSupervisor || null;
  const numRh = response.data?.numEmpleadoRH || null;
  const numEmpleado = response.data?.numEmpleado || null;

  let firmaEmpleado = '';
  let firmaSupervisor = '';
  let firmaRH = '';

  try {
    if (numEmpleado) {
      const res = await CatEmpleados.GetFotoFirma(numEmpleado, 'firma');
      firmaEmpleado = res || '';
    }
    if (numSupervisor) {
      const res = await CatEmpleados.GetFotoFirma(numSupervisor, 'firma');
      firmaSupervisor = res || '';
    }
    if (numRh) {
      const res = await CatEmpleados.GetFotoFirma(numRh, 'firma');
      firmaRH = res || '';
    }
  } catch (e) {
    console.error('Error al obtener firmas:', e);
  }

  const ventana = window.open('', '_blank');
  if (!ventana) {
    alert('Desactiva el bloqueador de ventanas emergentes.');
    return;
  }

ventana.document.write(`
  <html>
  <head>
    <meta charset="UTF-8">
    <title>Credencial de Permiso</title>
    <style>
      @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap');
      body {
        font-family: 'Roboto', sans-serif;
        background-color: #f0f0f0;
        padding: 40px;
      }
      .card {
        width: 650px;
        margin: auto;
        border-radius: 20px;
        overflow: hidden;
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
        background-color: #ffffff;
      }
      .header {
        background: linear-gradient(to right, #0052cc, #007fff);
        color: white;
        padding: 30px;
        text-align: center;
        position: relative;
      }
      .header img {
        position: absolute;
        left: 20px;
        top: 20px;
        width: 60px;
      }
      .header h2 {
        margin: 0;
        font-size: 26px;
      }
      .content {
        padding: 30px;
        font-size: 18px;
      }
      .row {
        margin-bottom: 14px;
      }
      .row strong {
        display: inline-block;
        width: 160px;
      }
      .firmas {
        display: flex;
        justify-content: space-around;
        padding: 20px 30px 30px;
      }
      .firma {
        width: 100px;
        height: 60px;
        border: 1px dashed #999;
        padding: 4px;
        text-align: center;
      }
      .firma img {
        max-width: 100%;
        max-height: 100%;
      }
      .footer {
        background-color: #f9f9f9;
        text-align: center;
        padding: 15px;
        font-size: 14px;
        color: #666;
      }
    </style>
  </head>
  <body>
    <div class="card">
      <div class="header">
        <img src="GEMCO.png" alt="Logo" />
        <h2>Credencial de Permiso</h2>
      </div>
      <div class="content">
        <div class="row"><strong>Empleado:</strong> ${row.nombreEmpleado}</div>
        <div class="row"><strong>Puesto:</strong> ${row.puestoEmpleado}</div>
        <div class="row"><strong>Motivo:</strong> ${row.motivo}</div>
        <div class="row"><strong>Fecha:</strong> ${formatearFecha(row.fechaPermiso)}</div>
        <div class="row"><strong>Horario:</strong> ${row.esDiaCompleto ? 'Día Completo' : `${row.horaInicio} - ${row.horaFin}`}</div>
        <div class="row"><strong>Estado:</strong> ${row.estado}</div>
       
      </div>
      <div class="firmas">
        <div class="firma"><img src="${firmaEmpleado}" alt="Firma Empleado" /></div>
        <div class="firma"><img src="${firmaSupervisor}" alt="Firma Supervisor" /></div>
        <div class="firma"><img src="${firmaRH}" alt="Firma RH" /></div>
      </div>
      <div class="footer">
        GEMCO | Nuevo Laredo, Tamps. <br />
        www.gemcousa.com
      </div>
    </div>
    <script>setTimeout(() => { window.print(); window.close(); }, 600);</script>
  </body>
  </html>
`);

  ventana.document.close();
};


const formatearFecha = (fecha: string) => {
  if (!fecha) return '';
  const date = new Date(fecha);
  const dia = date.getDate().toString().padStart(2, '0');
  const mes = (date.getMonth() + 1).toString().padStart(2, '0');
  const anio = date.getFullYear();
  return `${dia}/${mes}/${anio}`;
};



const getColorPorEstado = (estado: string) => {
  const colores = new Map<string, string>([
    ['Aceptado', '#d4edda'],      // Verde claro
    ['Rechazado', '#f8d7da'],     // Rojo claro
    ['Pendiente', '#ffcc99'],     // Naranja claro
    ['Anticipada', '#fff3cd'],    // Amarillo claro
    ['Sin solicitudes', 'white'], // Por si acaso
  ]);
  return colores.get(estado) || 'white';
};
  
  const columns = [
    {
      name: <strong><FaUserCheck className="me-2" />Empleado</strong>,
      selector: (row: DTOPermiso) => row.nombreEmpleado,
      sortable: true
    },
    {
      name: <strong><FaRegClock className="me-2" />Fecha Permiso</strong>,
      selector: (row: DTOPermiso) => row.fechaPermiso,
      sortable: true
    },
    { name: 'Motivo', selector: (row: DTOPermiso) => row.motivo },
    { name: 'Estado', selector: (row: DTOPermiso) => row.estado },
    { name: 'Fecha Solicitud', selector: (row: DTOPermiso) => row.fechaSolicitud, sortable: true },
    { name: 'Día Completo', selector: (row: DTOPermiso) => row.esDiaCompleto ? 'Sí' : 'No' },
    { name: 'Hora Inicio', selector: (row: DTOPermiso) => row.horaInicio },
    { name: 'Hora Fin', selector: (row: DTOPermiso) => row.horaFin },
    // { name: 'Observaciones', selector: (row: DTOPermiso) => row.observaciones }, 

    {
    name: <strong>Documentos</strong>,
    cell: (row: DTOPermiso) => (
      <div className="d-flex gap-2">
        <Button 
          variant="outline-primary" 
          size="sm" 
          title="Ver/Subir Comprobante"
          onClick={() => abrirModalAdjuntos(row)}
        >
          <BsFileEarmarkArrowUp />
        </Button>
        {/* Tu botón de PDF existente */}
        <Button
          variant="info"
          size="sm"
          onClick={() => generarCredencialPermiso(row)}
          disabled={row.estado !== 'Aceptado'}
        >
          PDF
        </Button>
      </div>
    ),
    width: '150px'
  }, 
// {
//   name: 'PDF',
//   cell: (row: DTOPermiso) => (
//     <Button
//       variant="info"
//       size="sm"
//       onClick={() => generarCredencialPermiso(row)}
//       disabled={row.estado !== 'Aceptado'}
//       title={row.estado !== 'Aceptado' ? 'Solo disponible si el permiso está aceptado' : 'Generar PDF'}
//     >
//       <i className="fas fa-file-pdf me-1"></i> PDF
//     </Button>
//   ),
//   ignoreRowClick: true,
//   allowOverflow: true,
//   button: true
// }

  ];



//   const abrirModalAdjuntos = async (permiso: DTOPermiso) => {
//   setPermisoSeleccionado(permiso);
//   // Buscamos adjuntos que coincidan con la fecha de este permiso
//   const res = await NominaServices.listarAdjuntos(permiso.numEmpleado, permiso.fechaPermiso);
//   setAdjuntosActuales(res.data || []);
//   setShowAdjuntosModal(true);
// };


const abrirModalAdjuntos = async (permiso: DTOPermiso) => {
    setPermisoSeleccionado(permiso);
    const res = await NominaServices.listarAdjuntos(permiso.numEmpleado, permiso.fechaPermiso);
    
    // 🔥 FILTRO: Aquí solo queremos ver PPA y PSS (Permisos)
    const soloPermisos = res.data.filter((a: any) => a.tipoAdjunto === 'PPA' || a.tipoAdjunto === 'PSS');
    
    setAdjuntosActuales(soloPermisos);
    setShowAdjuntosModal(true);
};




const manejarEliminarAdjunto = async (idAdjunto: string) => {
    if (!window.confirm("¿Estás seguro de eliminar este documento?")) return;

    try {
        await NominaServices.eliminarAdjunto(idAdjunto);
        
        setMsg("Documento eliminado");
        setHeader("Éxito");
        setShowMsg(true);
        
        
        if (permisoSeleccionado) {
            const res = await NominaServices.listarAdjuntos(
                permisoSeleccionado.numEmpleado, 
                permisoSeleccionado.fechaPermiso
            );

           
            const soloMisPermisos = (res.data || []).filter((adj: any) => 
                adj.tipoAdjunto === 'PPA' || adj.tipoAdjunto === 'PSS'
            );

            setAdjuntosActuales(soloMisPermisos);
        }
    } catch (error) {
        console.error("Error al eliminar:", error);
        setMsg("No se pudo eliminar el archivo");
        setHeader("Error");
        setShowMsg(true);
    }
};



  return (
    <div>


      
      <Card className="shadow-sm">
        <Card.Body>
          <Row className="mb-3">
            <Col>
              <Button variant="success" onClick={() => setShowModal(true)}>
                <FaPlusCircle className="me-2" />Nuevo Permiso
              </Button>
            </Col>
          </Row>
          <DataTable
            columns={columns}
            data={permisos}
            pagination
            highlightOnHover
            striped
            conditionalRowStyles={[
                {
                  when: (row: DTOPermiso) => true,
                  style: (row: DTOPermiso) => ({
                    backgroundColor: getColorPorEstado(row.estado),
                  }),
                },
              ]}
          />
        </Card.Body>
      </Card>

      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Nuevo Permiso</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Fecha del Permiso</Form.Label>
                  <Form.Control
                    type="date"
                    value={nuevoPermiso.fechaPermiso}
                    onChange={(e) => setNuevoPermiso({ ...nuevoPermiso, fechaPermiso: e.target.value })}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Nombre del Empleado</Form.Label>
                  <Form.Control type="text" value={nuevoPermiso.nombreEmpleado} readOnly />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Puesto</Form.Label>
                  <Form.Control type="text" value={nuevoPermiso.puestoEmpleado} readOnly />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Motivo</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    value={nuevoPermiso.motivo}
                    onChange={(e) => setNuevoPermiso({ ...nuevoPermiso, motivo: e.target.value })}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Form.Group className="mb-3">
              <Form.Check
                type="checkbox"
                label="¿Es día completo?"
                checked={nuevoPermiso.esDiaCompleto}
                onChange={(e) => setNuevoPermiso({ ...nuevoPermiso, esDiaCompleto: e.target.checked })}
              />
            </Form.Group>

            {!nuevoPermiso.esDiaCompleto && (
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Hora de salida</Form.Label>
                    <Form.Control
                      type="time"
                      value={nuevoPermiso.horaInicio}
                      onChange={(e) => setNuevoPermiso({ ...nuevoPermiso, horaInicio: e.target.value })}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Hora de regreso</Form.Label>
                    <Form.Control
                      type="time"
                      value={nuevoPermiso.horaFin}
                      onChange={(e) => setNuevoPermiso({ ...nuevoPermiso, horaFin: e.target.value })}
                    />
                  </Form.Group>
                </Col>
              </Row>
            )}

            {/* Dentro del modal de Nuevo Permiso, antes de cerrar el Form */}
<hr />
<Form.Group className="mb-3">
  <Form.Label className="fw-bold small text-primary">Subir Comprobante / Receta (Opcional)</Form.Label>
  <Form.Control 
    type="file" 
    size="sm" 
    accept=".jpg,.jpeg,.png,.pdf"
    onChange={(e: any) => setArchivoPermiso(e.target.files[0])} 
  />
  <Form.Text className="text-muted" style={{fontSize: 10}}>
    Puedes subirlo ahora o después de que sea aceptado.
  </Form.Text>
</Form.Group>



          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>Cancelar</Button>
          <Button variant="primary" onClick={insertarPermiso}>Guardar</Button>
        </Modal.Footer>
      </Modal>





<Modal show={showAdjuntosModal} onHide={() => { setShowAdjuntosModal(false); setArchivoPermiso(null); }} centered>
  <Modal.Header closeButton className="bg-light">
    <Modal.Title className="small fw-bold">Gestión de Documentos</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <div className="mb-3">
        <label className="fw-bold small">Documentos para el día: {permisoSeleccionado?.fechaPermiso.split('T')[0]}</label>
        {adjuntosActuales.length === 0 ? (
            <div className="text-center py-3 border rounded bg-light text-muted small">
                No hay archivos subidos aún.
            </div>
        ) : (
            <div className="d-flex flex-column gap-2 mt-2">
                {adjuntosActuales.map(adj => (
                    <div key={adj.id} className="p-2 border rounded d-flex justify-content-between align-items-center bg-white shadow-sm">
                        <div className="text-truncate small" style={{maxWidth: '200px'}}>
                            <BsFileEarmarkArrowUp className="me-2 text-primary"/>
                            {adj.nombreOriginal}
                        </div>
                        <div className="d-flex gap-1">
                            <Button variant="outline-info" size="sm" onClick={() => NominaServices.verAdjuntoEnNuevaPestana(adj.id)}>
                                <BsEye />
                            </Button>
                            <Button variant="outline-danger" size="sm" onClick={() => manejarEliminarAdjunto(adj.id)}>
                                <BsTrash />
                            </Button>
                        </div>
                    </div>
                ))}
            </div>
        )}
    </div>

    <hr />

    <Form.Group>
      <Form.Label className="small fw-bold">Subir nuevo comprobante:</Form.Label>
      <div className="d-flex gap-2">
        <Form.Control 
          type="file" 
          size="sm" 
          accept=".jpg,.jpeg,.png,.pdf"
          onChange={(e: any) => setArchivoPermiso(e.target.files[0])} 
        />
        <Button 
          variant="success" 
          size="sm" 
          disabled={!archivoPermiso}
          onClick={async () => {
    const formData = new FormData();
    formData.append("NumEmpleado", permisoSeleccionado!.numEmpleado);
    formData.append("FechaInicio", permisoSeleccionado!.fechaPermiso);
    formData.append("FechaFin", permisoSeleccionado!.fechaPermiso);

    // 🔥 Usamos la propiedad del permiso seleccionado
    const tipoParaDocumento = permisoSeleccionado!.esDiaCompleto ? "PSS" : "PPA";
    formData.append("TipoAdjunto", tipoParaDocumento);

    formData.append("Archivo", archivoPermiso!);
            await NominaServices.subirAdjunto(formData);
            setArchivoPermiso(null);
            // Limpiar el input file manualmente si es necesario
            const fileInput = document.querySelector('input[type="file"]') as HTMLInputElement;
            if (fileInput) fileInput.value = "";
            
            abrirModalAdjuntos(permisoSeleccionado!); // Recargar lista
          }}
        >

          
          Subir
        </Button>
      </div>
    </Form.Group>
  </Modal.Body>
</Modal>










      <MsgInformativo
        show={showMsg}
        msg={msg}
        header={header}
        msgColor={msgColor}
        closeToast={() => setShowMsg(false)}
      />
    </div>
  );
};

export default CatPermisosUsuario;
